import { PieChart } from '@/common/dashboard/charts/PieChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const McdDispBreakdownPieChart = ({ formValues }) => {

  const { rbtPeriodId, stateIds, ctrtIds, brandProdIds } = formValues;

  const rsrc = useRsrc();
  const [data, setData] = useState();
  const { navigateTo } = useNavState();

  const [prodIds, setProdIds] = useState([]);
  const [progIds, setProgIds] = useState([]);

  const handleClick = (clickData) => {
    let expr = ExprUtils.whereParams('rbtPeriodId', rbtPeriodId);
    let replaceParams = {};
    replaceParams['rbtPeriodId'] = rbtPeriodId;

    if (prodIds.length > 0) {
        const prodExpr = ExprUtils.whereParams('prodId', prodIds);
        expr = ExprUtils.and(expr, prodExpr);
        replaceParams['prodIds'] = prodIds;
      }

      if (stateIds.length > 0) {
        const stateExpr = ExprUtils.whereParams('mcdClaimStateId', stateIds);
        stateExpr.fkEntity = 'MCD_CLAIM';
        stateExpr.fkColPrefix = 'mcd_claim';
        expr = ExprUtils.and(expr, stateExpr);
        replaceParams['stateIds'] = stateIds;
      }

      if (progIds.length > 0) {
        const progExpr = ExprUtils.whereParams('mcdClaimProgId', progIds);
        progExpr.fkEntity = 'MCD_CLAIM';
        progExpr.fkColPrefix = 'mcd_claim';
        expr = ExprUtils.and(expr, progExpr);
        replaceParams['progIds'] = progIds;
      }

      replaceParams['statuses'] = ['PAID', 'DRAFT'];

      const rowsReq = {};
      // rowsReq.expr = expr;
      rowsReq.replaceParams = replaceParams;
      rowsReq.query = 'MCD_FIN_TREND_CLAIM_LINES';
      rsrc.rows('sc', 'MCD_CLAIM_LINE', rowsReq).then(rows => {
        const mcdClaimLineIds = rows.map(row => row.id);

        expr = ExprUtils.whereParams('mcdClaimLineId', mcdClaimLineIds, 'rbtPeriodId', rbtPeriodId, 'dispType', clickData.dispType);

        const navState = {
          mode: Mode.LIST,
          expr: expr,
        };
      navigateTo('/sc/mcd-disp', navState);
      });
  }

  useEffect(() => {
    const reqParam = {
      periodId: rbtPeriodId,
      stateIds,
      ctrtIds,
      brandIds: brandProdIds
    };

    rsrc.data('sc', 'MCD_DISP_BREAKDOWN_CHART_DATA_PLUGIN', reqParam).then(res => {
      setData(res.data);
      setProdIds(res.prodIds);
      setProgIds(res.progIds);
    });
  }, [rbtPeriodId, stateIds, ctrtIds, brandProdIds]);

  return (
    <PieChart
      data={
        data
      }
      onClick={handleClick}
    />
  );
};
